import { Directive, Input, TemplateRef } from "@angular/core";
// eslint-disable-next-line no-restricted-imports
import { NgxPermissionsDirective } from "ngx-permissions";

/* eslint-disable @typescript-eslint/no-explicit-any */

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "[hasFeature],[exceptFeature]",
})
export class FeatureFlagCheckDirective extends NgxPermissionsDirective {
    @Input({
        alias: "hasFeature",
        // NOTE: if value is empty string, it's converted to "?" because empty string always gives true
        transform: (value: string[] | string | undefined) => (value === "" ? undefined : value) ?? "?",
    })
    public ngxPermissionsOnly!: string | string[];
    @Input({ alias: "hasFeatureThen" }) public ngxPermissionsOnlyThen!: TemplateRef<any>;
    @Input({ alias: "hasFeatureElse" }) public ngxPermissionsOnlyElse!: TemplateRef<any>;

    @Input({
        alias: "exceptFeature",
        // NOTE: if value is empty string, it's converted to "?" because empty string always gives true
        transform: (value: string | undefined) => (value === "" ? undefined : value) ?? "?",
    })
    public ngxPermissionsExcept!: string | string[];
    @Input({ alias: "exceptFeatureElse" }) public ngxPermissionsExceptElse!: TemplateRef<any>;
    @Input({ alias: "exceptFeatureThen" }) public ngxPermissionsExceptThen!: TemplateRef<any>;

    @Input({ alias: "featureThen" }) public ngxPermissionsThen!: TemplateRef<any>;
    @Input({ alias: "featureElse" }) public ngxPermissionsElse!: TemplateRef<any>;
}
